export enum HangfireJobStatus {
    None = 0,
    Submitted = 1,
    ErrorOnSubmission = 2,
}
